export class ComplainantGender {
    get id() {
        return this.complainantGenderState.id;
    }
    get diligenceNumber() {
        return this.complainantGenderState.diligenceNumber;
    }
    get complainantThirId() {
        return this.complainantGenderState.complainantThirId;
    }
    get userId() {
        return this.complainantGenderState.complainantThirId;
    }
    get secretAddress() {
        return this.complainantGenderState.secretAddress;
    }
    get secretPhone() {
        return this.complainantGenderState.secretPhone;
    }
    get lawerToAssist() {
        return this.complainantGenderState.lawerToAssist;
    }
    get divorceMeasures() {
        return this.complainantGenderState.divorceMeasures;
    }
    get lawyerPhone() {
        return this.complainantGenderState.lawyerPhone;
    }
    get DatelawyerNotification() {
        return this.complainantGenderState.DatelawyerNotification;
    }
    get kinshipRelationId() {
        return this.complainantGenderState.kinshipRelationId;
    }
    get relationDuration() {
        return this.complainantGenderState.relationDuration;
    }
    get documentationRelation() {
        return this.complainantGenderState.documentationRelation;
    }
    get previousJudgments() {
        return this.complainantGenderState.previousJudgments;
    }
    get reportPreviousAttacker() {
        return this.complainantGenderState.reportPreviousAttacker;
    }
    get openJudgmentAggressor() {
        return this.complainantGenderState.openJudgmentAggressor;
    }
    get coexistsWithAggressor() {
        return this.complainantGenderState.coexistsWithAggressor;
    }
    get abandonAggressorAddress() {
        return this.complainantGenderState.abandonAggressorAddress;
    }
    get prohibitApproachingAggressor() {
        return this.complainantGenderState.prohibitApproachingAggressor;
    }
    get prohibitCommunicatingAggressor() {
        return this.complainantGenderState.prohibitCommunicatingAggressor;
    }
    get hasWeaponsAttacker() {
        return this.complainantGenderState.hasWeaponsAttacker;
    }
    get abandonHome() {
        return this.complainantGenderState.abandonHome;
    }
    get hostPossibility() {
        return this.complainantGenderState.hostPossibility;
    }
    get contactLawSchool() {
        return this.complainantGenderState.contactLawSchool;
    }
    get childrenOfRelation() {
        return this.complainantGenderState.childrenOfRelation;
    }
    get childrenAnotherRelation() {
        return this.complainantGenderState.childrenAnotherRelation;
    }
    get forbidCommunicatingChildren() {
        return this.complainantGenderState.forbidCommunicatingChildren;
    }
    get liveWithChildren() {
        return this.complainantGenderState.liveWithChildren;
    }
    get personalSituation() {
        return this.complainantGenderState.personalSituation;
    }
    get workSituationId() {
        return this.complainantGenderState.workSituationId;
    }
    get provisionalHousingAttribution() {
        return this.complainantGenderState.provisionalHousingAttribution;
    }
    get custodyChildren() {
        return this.complainantGenderState.custodyChildren;
    }
    get regimeVisitsVhildren() {
        return this.complainantGenderState.regimeVisitsVhildren;
    }
    get maintenanceCredit() {
        return this.complainantGenderState.maintenanceCredit;
    }
    get precautionaryMeasureJudged() {
        return this.complainantGenderState.precautionaryMeasureJudged;
    }
    get measureAdopt() {
        return this.complainantGenderState.measureAdopt;
    }
    get prohibitResidingAggressor() {
        return this.complainantGenderState.prohibitResidingAggressor;
    }
    get placeNotReside() {
        return this.complainantGenderState.placeNotReside;
    }
    get forbidTheAggressorToGo() {
        return this.complainantGenderState.forbidTheAggressorToGo;
    }
    get placesDoNotGo() {
        return this.complainantGenderState.placeNotReside;
    }
    get prohibitApproximatingAggressor() {
        return this.complainantGenderState.prohibitApproximatingAggressor;
    }
    get peopleDoNotApproximate() {
        return this.complainantGenderState.peopleDoNotApproximate;
    }
    get healthcareCenterAssistance() {
        return this.complainantGenderState.healthcareCenterAssistance;
    }
    get providesOptionalPart() {
        return this.complainantGenderState.providesOptionalPart;
    }
    get subsequentMedicalTreatment() {
        return this.complainantGenderState.subsequentMedicalTreatment;
    }
    get partsPreviousAggressions() {
        return this.complainantGenderState.partsPreviousAggressions;
    }
    get marriageRegimeId() {
        return this.complainantGenderState.marriageRegimeId;
    }
    get HouseTypeId() {
        return this.complainantGenderState.HouseTypeId;
    }
    get directionId() {
        return this.complainantGenderState.directionId;
    }
    get homeSecurityMeasures() {
        return this.complainantGenderState.homeSecurityMeasures;
    }
    get otherHouses() {
        return this.complainantGenderState.otherHouses;
    }
    get vehicles() {
        return this.complainantGenderState.vehicles;
    }
    get familyHelp() {
        return this.complainantGenderState.familyHelp;
    }
    set diligenceNumber(diligenceNumber) {
        this.complainantGenderState.diligenceNumber = diligenceNumber;
    }
    set complainantThirId(complainantThirId) {
        this.complainantGenderState.diligenceNumber = complainantThirId;
    }
    set userId(userId) {
        this.complainantGenderState.userId = userId;
    }
    set secretAddress(secretAddress) {
        this.complainantGenderState.secretAddress = secretAddress;
    }
    set secretPhone(secretPhone) {
        this.complainantGenderState.secretPhone = secretPhone;
    }
    set lawerToAssist(lawerToAssist) {
        this.complainantGenderState.lawerToAssist = lawerToAssist;
    }
    set divorceMeasures(divorceMeasures) {
        this.complainantGenderState.divorceMeasures = divorceMeasures;
    }
    set lawyerPhone(lawyerPhone) {
        this.complainantGenderState.lawyerPhone = lawyerPhone;
    }
    set DatelawyerNotification(DatelawyerNotification) {
        this.complainantGenderState.DatelawyerNotification = DatelawyerNotification;
    }
    set kinshipRelationId(kinshipRelationId) {
        this.complainantGenderState.kinshipRelationId = kinshipRelationId;
    }
    set relationDuration(relationDuration) {
        this.complainantGenderState.relationDuration = relationDuration;
    }
    set previousJudgments(previousJudgments) {
        this.complainantGenderState.previousJudgments = previousJudgments;
    }
    set reportPreviousAttacker(reportPreviousAttacker) {
        this.complainantGenderState.reportPreviousAttacker = reportPreviousAttacker;
    }
    set openJudgmentAggressor(openJudgmentAggressor) {
        this.complainantGenderState.openJudgmentAggressor = openJudgmentAggressor;
    }
    set coexistsWithAggressor(coexistsWithAggressor) {
        this.complainantGenderState.coexistsWithAggressor = coexistsWithAggressor;
    }
    set abandonAggressorAddress(abandonAggressorAddress) {
        this.complainantGenderState.abandonAggressorAddress = abandonAggressorAddress;
    }
    set prohibitApproachingAggressor(prohibitApproachingAggressor) {
        this.complainantGenderState.prohibitApproachingAggressor = prohibitApproachingAggressor;
    }
    set prohibitCommunicatingAggressor(prohibitCommunicatingAggressor) {
        this.complainantGenderState.prohibitCommunicatingAggressor = prohibitCommunicatingAggressor;
    }
    set hasWeaponsAttacker(hasWeaponsAttacker) {
        this.complainantGenderState.hasWeaponsAttacker = hasWeaponsAttacker;
    }
    set abandonHome(abandonHome) {
        this.complainantGenderState.abandonHome = abandonHome;
    }
    set hostPossibility(hostPossibility) {
        this.complainantGenderState.hostPossibility = hostPossibility;
    }
    set contactLawSchool(contactLawSchool) {
        this.complainantGenderState.contactLawSchool = contactLawSchool;
    }
    set childrenOfRelation(childrenOfRelation) {
        this.complainantGenderState.childrenOfRelation = childrenOfRelation;
    }
    set childrenAnotherRelation(childrenAnotherRelation) {
        this.complainantGenderState.childrenAnotherRelation = childrenAnotherRelation;
    }
    set forbidCommunicatingChildren(forbidCommunicatingChildren) {
        this.complainantGenderState.forbidCommunicatingChildren = forbidCommunicatingChildren;
    }
    set liveWithChildren(liveWithChildren) {
        this.complainantGenderState.liveWithChildren = liveWithChildren;
    }
    set personalSituation(personalSituation) {
        this.complainantGenderState.personalSituation = personalSituation;
    }
    set workSituationId(workSituationId) {
        this.complainantGenderState.workSituationId = workSituationId;
    }
    set provisionalHousingAttribution(provisionalHousingAttribution) {
        this.complainantGenderState.provisionalHousingAttribution = provisionalHousingAttribution;
    }
    set custodyChildren(custodyChildren) {
        this.complainantGenderState.custodyChildren = custodyChildren;
    }
    set regimeVisitsVhildren(regimeVisitsVhildren) {
        this.complainantGenderState.regimeVisitsVhildren = regimeVisitsVhildren;
    }
    set maintenanceCredit(maintenanceCredit) {
        this.complainantGenderState.maintenanceCredit = maintenanceCredit;
    }
    set precautionaryMeasureJudged(precautionaryMeasureJudged) {
        this.complainantGenderState.precautionaryMeasureJudged = precautionaryMeasureJudged;
    }
    set prohibitResidingAggressor(prohibitResidingAggressor) {
        this.complainantGenderState.prohibitResidingAggressor = prohibitResidingAggressor;
    }
    set placeNotReside(placeNotReside) {
        this.complainantGenderState.placeNotReside = placeNotReside;
    }
    set forbidTheAggressorToGo(forbidTheAggressorToGo) {
        this.complainantGenderState.forbidTheAggressorToGo = forbidTheAggressorToGo;
    }
    set placesDoNotGo(placesDoNotGo) {
        this.complainantGenderState.placesDoNotGo = placesDoNotGo;
    }
    set prohibitApproximatingAggressor(prohibitApproximatingAggressor) {
        this.complainantGenderState.prohibitApproximatingAggressor = prohibitApproximatingAggressor;
    }
    set peopleDoNotApproximate(peopleDoNotApproximate) {
        this.complainantGenderState.peopleDoNotApproximate = peopleDoNotApproximate;
    }
    set healthcareCenterAssistance(healthcareCenterAssistance) {
        this.complainantGenderState.healthcareCenterAssistance = healthcareCenterAssistance;
    }
    set providesOptionalPart(providesOptionalPart) {
        this.complainantGenderState.providesOptionalPart = providesOptionalPart;
    }
    set subsequentMedicalTreatment(subsequentMedicalTreatment) {
        this.complainantGenderState.subsequentMedicalTreatment = subsequentMedicalTreatment;
    }
    set partsPreviousAggressions(partsPreviousAggressions) {
        this.complainantGenderState.partsPreviousAggressions = partsPreviousAggressions;
    }
    set marriageRegimeId(marriageRegimeId) {
        this.complainantGenderState.marriageRegimeId = marriageRegimeId;
    }
    set HouseTypeId(HouseTypeId) {
        this.complainantGenderState.HouseTypeId = HouseTypeId;
    }
    set directionId(directionId) {
        this.complainantGenderState.directionId = directionId;
    }
    set homeSecurityMeasures(homeSecurityMeasures) {
        this.complainantGenderState.homeSecurityMeasures = homeSecurityMeasures;
    }
    set otherHouses(otherHouses) {
        this.complainantGenderState.otherHouses = otherHouses;
    }
    set vehicles(vehicles) {
        this.complainantGenderState.vehicles = vehicles;
    }
    set familyHelp(familyHelp) {
        this.complainantGenderState.familyHelp = familyHelp;
    }
    constructor(complainantGenderState) {
        this.complainantGenderState = complainantGenderState;
    }
    getState() {
        return this.complainantGenderState;
    }
}
